// import React, { useState } from "react";

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing163({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/151/1.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/163/2.gif`}
      formFieldColor="white"
      qTitleColor="#4287f5"
      qOptionColor="blue"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/applyButton2.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      eventDates={true}
    />
  );
}

export default Randing163;
